module.exports = __webpack_public_path__ + "static/media/Tasks.1a563d9a.png";